import './About.css';
import Footer from '../components/Footer.js'; 

const About = () => {
  return (
    <div>
    <div className="about-page">
      <section className="hero-about">
        <h1>About Our Firm</h1>
        <p>Kagwe, Kamau & Karanja Advocates was founded in 2003 and today the law firm has grown to be a leading boutique Law Firm in Kenya.

Since its inception, the management has spent time and resources setting up systems, procedures and adopting innovative strategies aimed at delivering timely and excellent legal services to our clients under the written laws.

Every client in Kagwe, Kamau & Karanja Advocates is handled professionally with ultimate care and respect.</p>
      </section>

      <section className="timeline-section">
        <div className="timeline">
          <div className="timeline-item">
            <h3>Mission Statement</h3>
            <p>Provision of effective and professional legal services in a timely manner to our clients with utmost integrity.</p>
          </div>
          <div className="timeline-item">
            <h3>Our Philosophy</h3>
            <p>Every Client Matters.</p>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="stats-grid">
          <div className="stat-card">
            <h3>Focus: Real Estate Legal Consultancy</h3>
            <p>This has been the core business of the law firm since its inception. We endeavour to deliver to our Real Estate Clientele ranging from Developers, Private Investors, Individual Buyers/Sellers, Landlords/Tenants to Management Companies with Quality and Timely Legal Services along the entire Real Estate Value-Chain in the most Cost-Effective way.

Indeed, we have successfully handled several residential/commercial development projects in Nairobi, Machakos, Nakuru and Eldoret from ground-breaking to handing-over. The real estate legal consultancy services include:

Pre-development due diligence,

Statutory compliance matters,

Project Financing,

Liaison with Project Managers,

The Actual Conveyancing Cycle,

Handing-over,

Post-development matters.</p>
          </div>
        </div>
      </section>

    </div>
          <Footer />
    </div>
  );
};

export default About;